import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FacLogErrorService {

  private baseComponente = '/FactPrueba/FactLogError';

  constructor(private http: HttpClient) {
  }

  getListAllFacLogError(): Observable<any> {
    return this.http.get(`${environment.backend.concat(this.baseComponente).concat('/listarFactLogError')}`);
  }

  getFacLogError(factLogErrorId: number): Observable<any> {
    return this.http.get(`${environment.backend.concat(this.baseComponente).concat('/listarFactLogErrorId')}/${factLogErrorId}`);
  }

  saveFacLogError(factLogError: any): Observable<any> {
    return this.http.post(`${environment.backend.concat(this.baseComponente).concat('/crearFactLogError')}`, factLogError);
  }

  editFacLogError(factLogError: any): Observable<any> {
    return this.http.put(`${environment.backend.concat(this.baseComponente).concat('/editarFactLogError')}`, factLogError);
  }
}
